import React from "react";
import { cn } from "@/lib/utils";

/**
 * ContentContainer — canonical page-content wrapper.
 *
 * Every route inside AppNav / AdminLayout wraps its main body in this
 * primitive so max-width, horizontal padding, vertical rhythm, and
 * responsive breakpoints stay uniform across the app.
 *
 * Variants:
 *   * width:
 *       - "narrow"  → max-w-2xl   (forms, prose, single-column pages)
 *       - "default" → max-w-5xl   (dashboard, list pages)
 *       - "wide"    → max-w-7xl   (data-dense admin tables)
 *       - "full"    → no max      (edge-to-edge composition)
 *   * padded (default true) — apply px + py; disable for hero rows that
 *     already handle their own padding.
 */

const WIDTH_CLASS = {
  narrow: "max-w-2xl",
  default: "max-w-5xl",
  wide: "max-w-7xl",
  full: "",
};

export function ContentContainer({
  width = "default",
  padded = true,
  as: Tag = "main",
  className,
  children,
  "data-testid": testId,
  ...rest
}) {
  return (
    <Tag
      data-testid={testId}
      className={cn(
        "mx-auto w-full",
        WIDTH_CLASS[width] || WIDTH_CLASS.default,
        padded && "px-4 sm:px-6 lg:px-8 py-6",
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default ContentContainer;
